import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatJson } from '@/utils/index';
import { fetchList, fetchDelete, longTermImportData } from '@/api/PMS/longTermReservation/longReservationImport'; // import { fetchDict } from "@/api/MLXC/countryServe/partyManage";
// import { fetchList as placeList } from "@/api/PMS/placeManage/placeManage";
// import {
//   fetchList,
//   fetchDelete,
// } from "@/api/PMS/longTermReservation/longTermReservation";

import waves from "@/directive/waves"; // 水波纹指令
// import add from "./add";
// import { ceretLongBooksInfo } from '@/api/PMS/placeBookInfo/placeBookInfo.js'
// 导入弹出框

import importExcel from "./import";
export default {
  name: "ComplexTable",
  components: {
    // add,
    importExcel: importExcel
  },
  directives: {
    waves: waves
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  data: function data() {
    return {
      dates: [],
      placeOptions: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      Id: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      statusOptions: [],
      companyList: [],
      // 导入
      dialogExcelVisible: false,
      exLists: [],
      slist: []
    };
  },
  created: function created() {
    // this.getType();
    // this.getCompany();
    this.init(); // this.getPlace();
  },
  methods: {
    // 导入
    handleUpload: function handleUpload() {
      this.title = "导入Excel";
      this.dialogExcelVisible = true;
    },
    getPlace: function getPlace() {
      var _this = this;

      placeList({}).then(function (res) {
        _this.placeOptions = res.data.data;
      });
    },
    getCompany: function getCompany() {
      var _this2 = this;

      fetchCompanyList({}).then(function (res) {
        _this2.companyList = res.data.data;
      });
    },
    init: function init() {
      this.listQuery = {
        page: 1,
        limit: 10,
        startTime: '',
        endTime: ''
      };
      this.total = null;
      this.getList();
    },
    handlePlaceLock: function handlePlaceLock() {
      var _this3 = this;

      this.$confirm('根据当前配置信息更新锁场, 是否继续?', '提示').then(function () {
        ceretLongBooksInfo().then(function () {
          _this3.Alert({
            alertType: 'add',
            message: '操作成功'
          });
        });
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogExcelVisible = false;
      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this4 = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.startTime = this.dates[0];
        this.listQuery.endTime = this.dates[1];
      } else {
        this.listQuery.startTime = "";
        this.listQuery.endTime = "";
      }

      fetchList(this.listQuery).then(function (response) {
        _this4.list = response.data.data;
        _this4.total = response.data.total;
        _this4.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.Id = -1;
      this.title = "添加";
      this.dialogFormVisible = true;
    },
    // 导出
    handleExport: function handleExport(id) {
      var _this5 = this;

      this.exLists = [];
      this.$confirm("你确定要导出长期订场导入明细吗, 是否继续?", "提示").then(function () {
        longTermImportData({
          importId: id
        }).then(function (response) {
          var list = response.data.data;

          if (list !== null && list.length > 0) {
            var arrayWithIndex = list.map(function (item, index) {
              return _objectSpread({
                index: index + 1
              }, item);
            });
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["序号", "场地", "星期", "时间段", "开始时间", "结束时间", "备注", "错误原因"];
              var fileterVal = ["index", "placeName", "weekName", "periodName", "startTime", "endTime", "remark", "errorReason"]; // const multiHeader = [
              //   ["长期订场导入明细", "", "", "", "", "", "", ""]
              // ];
              // let merges = ["A1:H1"];

              var data = formatJson(fileterVal, arrayWithIndex);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                // merges: merges,
                // multiHeader: multiHeader,
                filename: "长期订场导入明细",
                autoWidth: true,
                bookType: "xls"
              });
            });
          } else {
            _this5.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    },
    delete: function _delete(Ids) {
      var _this6 = this;

      if (Ids.length > 0) {
        this.$confirm("你确定是要删除这些记录, 是否继续?", "提示").then(function () {
          fetchDelete(Ids).then(function (response) {
            _this6.getList();

            _this6.Alert({
              alertType: "delete"
            });
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(Id) {
      var Ids = [];
      Ids.push(Id);
      this.delete(Ids);
    },
    handleDeletes: function handleDeletes() {
      var Ids = [];
      this.multipleSelection.forEach(function (row) {
        Ids.push(row.id);
      });
      this.delete(Ids);
    }
  }
};